__turbopack_export_value__({
  "className": "minionprofontfamily_668cc215-module__KfqVJW__className",
  "variable": "minionprofontfamily_668cc215-module__KfqVJW__variable",
});
